import remote from './remote';

export function getCountries() {
  return remote.get('countries');
}

export function getCountryStates(countryId) {
  return remote.get(`countries/${countryId}/states`);
}
